import React from 'react';

import { BaseIconProps } from './';

export const OtherEstate = ({ fill }: BaseIconProps) => (
  <g
    id="g218"
    transform="matrix(21.595458,0,0,21.595458,0.11167185,-8.4148272)"
    strokeWidth="0.04630603"
  >
    <path
      fill="#ffffff"
      strokeWidth="0.04630603"
      d="M 48.809,18.257 25,1.59 1.19,18.257 V 49.209 H 9.127 V 25.003 h 31.746 v 24.206 h 7.936 z"
    />
    <path
      fill={fill}
      strokeWidth="0.04630603"
      d="m 28.57,18.651 h -7.54 a 1.17,1.17 0 0 1 -1.19,-1.19 c 0,-0.675 0.516,-1.191 1.19,-1.191 h 7.54 c 0.675,0 1.19,0.516 1.19,1.19 a 1.17,1.17 0 0 1 -1.19,1.19 z"
    />
    <path
      fill={fill}
      strokeWidth="0.04630603"
      id="path198"
      d="M 47.62,48.019 H 42.063 V 25.003 a 1.17,1.17 0 0 0 -1.19,-1.19 H 9.127 a 1.17,1.17 0 0 0 -1.19,1.19 V 48.02 H 2.38 V 18.892 L 25,3.059 47.62,18.892 Z M 49.484,17.265 25.674,0.598 a 1.196,1.196 0 0 0 -1.349,0 L 0.515,17.265 A 1.24,1.24 0 0 0 0,18.257 V 49.21 c 0,0.675 0.516,1.19 1.19,1.19 H 48.81 A 1.17,1.17 0 0 0 50,49.21 V 18.257 a 1.24,1.24 0 0 0 -0.516,-0.992 z"
    />
    <path
      fill="#ffffff"
      strokeWidth="0.04630603"
      d="M 28.573,26.98 H 26.59 c -0.238,0 -0.397,0.159 -0.397,0.397 v 1.587 c 0,0.675 -2.38,0.675 -2.38,0 v -1.587 c 0,-0.238 -0.16,-0.397 -0.397,-0.397 H 21.43 a 1.17,1.17 0 0 0 -1.19,1.19 v 7.143 c 0,0.675 0.516,1.19 1.19,1.19 h 7.143 a 1.17,1.17 0 0 0 1.19,-1.19 V 28.17 a 1.17,1.17 0 0 0 -1.19,-1.19 z m 5.95,11.51 H 32.54 c -0.238,0 -0.397,0.159 -0.397,0.397 v 1.587 c 0,0.675 -2.38,0.675 -2.38,0 v -1.587 c 0,-0.238 -0.16,-0.397 -0.397,-0.397 H 27.38 a 1.17,1.17 0 0 0 -1.19,1.19 v 7.143 c 0,0.675 0.516,1.19 1.19,1.19 h 7.143 a 1.17,1.17 0 0 0 1.19,-1.19 V 39.68 a 1.17,1.17 0 0 0 -1.19,-1.19 z m -11.9,0 H 20.64 c -0.238,0 -0.397,0.159 -0.397,0.397 v 1.587 c 0,0.675 -2.38,0.675 -2.38,0 v -1.587 c 0,-0.238 -0.16,-0.397 -0.397,-0.397 H 15.48 a 1.17,1.17 0 0 0 -1.19,1.19 v 7.143 c 0,0.675 0.516,1.19 1.19,1.19 h 7.143 a 1.17,1.17 0 0 0 1.19,-1.19 V 39.68 a 1.17,1.17 0 0 0 -1.19,-1.19 z"
    />
  </g>
);
